<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'90%'">
        <v-card>
            <v-card-title class="primary modal-title d-flex justify-space-between pr-0" primary-title>
                <div>
                    Response Body
                </div>
                <v-menu v-if="isValidJson(responseBody) && apenasVisualizar" style="display: flex; justify-content: flex-end" offset-y left>
                    <v-btn slot="activator" dark icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list class="py-3">
                        <v-list-tile @click.stop>
                            <v-switch v-model="embelezar"/>
                            <span @click="embelezar = !embelezar">Embelezar texto</span>
                        </v-list-tile>
                        <v-list-tile @click.stop v-if="embelezar">
                            <v-switch v-model="exibirAspas"/>
                            <span @click="exibirAspas = !exibirAspas">Adicionar aspas</span>
                        </v-list-tile>
                        <v-list-tile @click.stop v-if="embelezar">
                            <v-switch v-model="urlClicavel"/>
                            <span @click="urlClicavel = !urlClicavel">Ativar links</span>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span v-if="apenasVisualizar">
                    Este é o response body da requisição de numero {{requisicaoEditar.id}}:
                </span>
                <span v-if="!apenasVisualizar">
                    Escreva uma response body para a requisição de numero {{requisicaoEditar.id}}:
                </span>

                <br>

                <v-divider class="my-3"/>

                <campo-vazio-mensagem v-if="apenasVisualizar && !responseBody" :mensagem="'Não há conteúdo no response body desta requisição!'"/>

                <span v-if="!!responseBody && apenasVisualizar && isValidJson(responseBody) && embelezar"
                      style="white-space: pre-wrap; word-wrap: break-word"
                      v-html="responseBodyEmbelezado()"/>

                <span v-if="!!responseBody && apenasVisualizar && (!isValidJson(responseBody) || !embelezar)"
                      style="white-space: pre-wrap; word-wrap: break-word">{{responseBody}}</span>

                <v-textarea v-if="!apenasVisualizar"
                            v-model="responseBody"
                            :error-messages="errors.collect('Response Body id ' + requisicaoEditar.id)"
                            v-validate="''"
                            :name="'Response Body id ' + requisicaoEditar.id"
                            label="Response Body"
                            placeholder="Digite o body"
                            rows="6"/>

            </v-card-text>

            <v-card-actions>
                <v-layout v-if="apenasVisualizar" class="justify-center">
                    <az-call-to-action id="botaoFechar"
                                       @click="$emit('cancelar')"
                                       css-class="botao-desativado" class="ma-2 py-2"
                                       slot="actions">
                        Fechar
                    </az-call-to-action>
                </v-layout>
                <v-flex v-else>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoCancelar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoConfirmar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { prettyPrintJson } from 'pretty-print-json'
import CampoVazioMensagem from './CampoVazioMensagem'
export default {
    name: 'ModalEditarResponseBodyRequisicao',
    components: {CampoVazioMensagem},
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        },
        apenasVisualizar:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            responseBody: null,
            embelezar: true,
            exibirAspas: true,
            urlClicavel: false
        }
    },
    computed: {
        requisicaoResponseBody() {
            return this.requisicaoEditar.responseBody
        }
    },
    mounted() {
        this.responseBody = this.requisicaoResponseBody
    },
    methods:{
        confirmar() {
            this.requisicaoEditar.responseBody = this.responseBody
            this.$emit('confirmar', this.requisicaoEditar)
        },
        responseBodyEmbelezado(){
            if(!this.isValidJson(this.responseBody)){
                return ''
            }
            const opcoesPrettify = {
                linkUrls: this.urlClicavel,
                quoteKeys: this.exibirAspas,
                indent: 6
            }
            return prettyPrintJson.toHtml(JSON.parse(this.responseBody), opcoesPrettify)
        },
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
